
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/turkey",
      function () {
        return require("private-next-pages/recipes/turkey.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/turkey"])
      });
    }
  